import { kebabCase } from 'lodash';
import { useQuery } from 'react-query';

import {
  NEWSLETTER_SUBSCRIPTIONS_KEY,
  NewsletterSubscriptions,
  getNewsletterSubscriptions,
} from '../utils/backend-api/newsletters';

const buildNewsletter = (newsletters) => {
  if (!newsletters) return undefined;
  return newsletters.map((newsletter) => ({
    slug: kebabCase(newsletter.name),
    newsletterId: newsletter.id,
    title: newsletter.name,
    subheader: newsletter.description,
    isSubscribed: newsletter.current_user_subscribed,
    frequency: newsletter.frequency,
    author: newsletter.author,
    isPro: newsletter.is_pro_only,
  }));
};

export default function useNewsletterSubscriptions() {
  const { data, isLoading: isLoadingNewsletterSubscriptions } = useQuery<NewsletterSubscriptions>(
    NEWSLETTER_SUBSCRIPTIONS_KEY,
    () => getNewsletterSubscriptions()
  );

  return { newsletters: buildNewsletter(data), isLoadingNewsletterSubscriptions };
}
